module.exports = __webpack_public_path__ + "static/logo-meiquer-laureles-cbc3c843d3eb99faa7ae8ffee7b6bc4d.png";